/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetMenuListDocument = gql`
    query GetMenuList($companyId: Int!, $branchId: Int, $page: Int, $itemsPerPage: Int, $search: String, $menuTypeId: Int) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      branchesPaginated(id: $branchId) {
        branches {
          menus(
            page: $page
            itemsPerPage: $itemsPerPage
            search: $search
            menuTypeId: $menuTypeId
          ) {
            menus {
              id
              name
              type {
                id
                name
                slug
              }
              status {
                id
                name
                slug
              }
              languages {
                id
                name
              }
              primaryLanguage {
                id
                name
              }
              numberOfCategories
              numberOfItems
              deleted
            }
            totalCount
            currentPage
            itemsPerPage
            pageCount
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMenuListQuery__
 *
 * To run a query within a React component, call `useGetMenuListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuListQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      search: // value for 'search'
 *      menuTypeId: // value for 'menuTypeId'
 *   },
 * });
 */
export function useGetMenuListQuery(baseOptions: Apollo.QueryHookOptions<GetMenuListQuery, GetMenuListQueryVariables> & ({ variables: GetMenuListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuListQuery, GetMenuListQueryVariables>(GetMenuListDocument, options);
      }
export function useGetMenuListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuListQuery, GetMenuListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuListQuery, GetMenuListQueryVariables>(GetMenuListDocument, options);
        }
export function useGetMenuListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuListQuery, GetMenuListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuListQuery, GetMenuListQueryVariables>(GetMenuListDocument, options);
        }
export type GetMenuListQueryHookResult = ReturnType<typeof useGetMenuListQuery>;
export type GetMenuListLazyQueryHookResult = ReturnType<typeof useGetMenuListLazyQuery>;
export type GetMenuListSuspenseQueryHookResult = ReturnType<typeof useGetMenuListSuspenseQuery>;
export type GetMenuListQueryResult = Apollo.QueryResult<GetMenuListQuery, GetMenuListQueryVariables>;
export const MenuTypesDocument = gql`
    query MenuTypes {
  menuTypes {
    id
    name
    slug
  }
}
    `;

/**
 * __useMenuTypesQuery__
 *
 * To run a query within a React component, call `useMenuTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenuTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenuTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMenuTypesQuery(baseOptions?: Apollo.QueryHookOptions<MenuTypesQuery, MenuTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MenuTypesQuery, MenuTypesQueryVariables>(MenuTypesDocument, options);
      }
export function useMenuTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MenuTypesQuery, MenuTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MenuTypesQuery, MenuTypesQueryVariables>(MenuTypesDocument, options);
        }
export function useMenuTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MenuTypesQuery, MenuTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MenuTypesQuery, MenuTypesQueryVariables>(MenuTypesDocument, options);
        }
export type MenuTypesQueryHookResult = ReturnType<typeof useMenuTypesQuery>;
export type MenuTypesLazyQueryHookResult = ReturnType<typeof useMenuTypesLazyQuery>;
export type MenuTypesSuspenseQueryHookResult = ReturnType<typeof useMenuTypesSuspenseQuery>;
export type MenuTypesQueryResult = Apollo.QueryResult<MenuTypesQuery, MenuTypesQueryVariables>;
export const GetLanguageVersionsDocument = gql`
    query GetLanguageVersions($companyId: Int!) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      languages {
        id
        name
        isoCode
      }
      primaryLanguage {
        id
        name
        isoCode
      }
    }
  }
}
    `;

/**
 * __useGetLanguageVersionsQuery__
 *
 * To run a query within a React component, call `useGetLanguageVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLanguageVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLanguageVersionsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetLanguageVersionsQuery(baseOptions: Apollo.QueryHookOptions<GetLanguageVersionsQuery, GetLanguageVersionsQueryVariables> & ({ variables: GetLanguageVersionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLanguageVersionsQuery, GetLanguageVersionsQueryVariables>(GetLanguageVersionsDocument, options);
      }
export function useGetLanguageVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLanguageVersionsQuery, GetLanguageVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLanguageVersionsQuery, GetLanguageVersionsQueryVariables>(GetLanguageVersionsDocument, options);
        }
export function useGetLanguageVersionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLanguageVersionsQuery, GetLanguageVersionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLanguageVersionsQuery, GetLanguageVersionsQueryVariables>(GetLanguageVersionsDocument, options);
        }
export type GetLanguageVersionsQueryHookResult = ReturnType<typeof useGetLanguageVersionsQuery>;
export type GetLanguageVersionsLazyQueryHookResult = ReturnType<typeof useGetLanguageVersionsLazyQuery>;
export type GetLanguageVersionsSuspenseQueryHookResult = ReturnType<typeof useGetLanguageVersionsSuspenseQuery>;
export type GetLanguageVersionsQueryResult = Apollo.QueryResult<GetLanguageVersionsQuery, GetLanguageVersionsQueryVariables>;
export const CreateMenuDocument = gql`
    mutation CreateMenu($branchId: Int!, $input: MenuInput!) {
  createMenu(branchId: $branchId, input: $input) {
    id
  }
}
    `;
export type CreateMenuMutationFn = Apollo.MutationFunction<CreateMenuMutation, CreateMenuMutationVariables>;

/**
 * __useCreateMenuMutation__
 *
 * To run a mutation, you first call `useCreateMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMenuMutation, { data, loading, error }] = useCreateMenuMutation({
 *   variables: {
 *      branchId: // value for 'branchId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMenuMutation(baseOptions?: Apollo.MutationHookOptions<CreateMenuMutation, CreateMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMenuMutation, CreateMenuMutationVariables>(CreateMenuDocument, options);
      }
export type CreateMenuMutationHookResult = ReturnType<typeof useCreateMenuMutation>;
export type CreateMenuMutationResult = Apollo.MutationResult<CreateMenuMutation>;
export type CreateMenuMutationOptions = Apollo.BaseMutationOptions<CreateMenuMutation, CreateMenuMutationVariables>;
export const UpdateMenuDocument = gql`
    mutation UpdateMenu($menuId: Int!, $branchId: Int!, $input: MenuInput!, $allowArchive: Boolean) {
  updateMenu(
    id: $menuId
    branchId: $branchId
    input: $input
    allowArchive: $allowArchive
  ) {
    id
  }
}
    `;
export type UpdateMenuMutationFn = Apollo.MutationFunction<UpdateMenuMutation, UpdateMenuMutationVariables>;

/**
 * __useUpdateMenuMutation__
 *
 * To run a mutation, you first call `useUpdateMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMenuMutation, { data, loading, error }] = useUpdateMenuMutation({
 *   variables: {
 *      menuId: // value for 'menuId'
 *      branchId: // value for 'branchId'
 *      input: // value for 'input'
 *      allowArchive: // value for 'allowArchive'
 *   },
 * });
 */
export function useUpdateMenuMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMenuMutation, UpdateMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMenuMutation, UpdateMenuMutationVariables>(UpdateMenuDocument, options);
      }
export type UpdateMenuMutationHookResult = ReturnType<typeof useUpdateMenuMutation>;
export type UpdateMenuMutationResult = Apollo.MutationResult<UpdateMenuMutation>;
export type UpdateMenuMutationOptions = Apollo.BaseMutationOptions<UpdateMenuMutation, UpdateMenuMutationVariables>;
export const DeleteMenuDocument = gql`
    mutation DeleteMenu($branchId: Int!, $id: Int!) {
  deleteMenu(branchId: $branchId, id: $id)
}
    `;
export type DeleteMenuMutationFn = Apollo.MutationFunction<DeleteMenuMutation, DeleteMenuMutationVariables>;

/**
 * __useDeleteMenuMutation__
 *
 * To run a mutation, you first call `useDeleteMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMenuMutation, { data, loading, error }] = useDeleteMenuMutation({
 *   variables: {
 *      branchId: // value for 'branchId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMenuMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMenuMutation, DeleteMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMenuMutation, DeleteMenuMutationVariables>(DeleteMenuDocument, options);
      }
export type DeleteMenuMutationHookResult = ReturnType<typeof useDeleteMenuMutation>;
export type DeleteMenuMutationResult = Apollo.MutationResult<DeleteMenuMutation>;
export type DeleteMenuMutationOptions = Apollo.BaseMutationOptions<DeleteMenuMutation, DeleteMenuMutationVariables>;
export const RestoreMenuDocument = gql`
    mutation RestoreMenu($branchId: Int!, $id: Int!) {
  restoreMenu(branchId: $branchId, id: $id)
}
    `;
export type RestoreMenuMutationFn = Apollo.MutationFunction<RestoreMenuMutation, RestoreMenuMutationVariables>;

/**
 * __useRestoreMenuMutation__
 *
 * To run a mutation, you first call `useRestoreMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreMenuMutation, { data, loading, error }] = useRestoreMenuMutation({
 *   variables: {
 *      branchId: // value for 'branchId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreMenuMutation(baseOptions?: Apollo.MutationHookOptions<RestoreMenuMutation, RestoreMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreMenuMutation, RestoreMenuMutationVariables>(RestoreMenuDocument, options);
      }
export type RestoreMenuMutationHookResult = ReturnType<typeof useRestoreMenuMutation>;
export type RestoreMenuMutationResult = Apollo.MutationResult<RestoreMenuMutation>;
export type RestoreMenuMutationOptions = Apollo.BaseMutationOptions<RestoreMenuMutation, RestoreMenuMutationVariables>;
export const CloneMenuDocument = gql`
    mutation CloneMenu($cloneMenuId: Int!, $branchId: Int!, $input: MenuInput!) {
  cloneMenu(cloneMenuId: $cloneMenuId, branchId: $branchId, input: $input) {
    id
  }
}
    `;
export type CloneMenuMutationFn = Apollo.MutationFunction<CloneMenuMutation, CloneMenuMutationVariables>;

/**
 * __useCloneMenuMutation__
 *
 * To run a mutation, you first call `useCloneMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneMenuMutation, { data, loading, error }] = useCloneMenuMutation({
 *   variables: {
 *      cloneMenuId: // value for 'cloneMenuId'
 *      branchId: // value for 'branchId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloneMenuMutation(baseOptions?: Apollo.MutationHookOptions<CloneMenuMutation, CloneMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneMenuMutation, CloneMenuMutationVariables>(CloneMenuDocument, options);
      }
export type CloneMenuMutationHookResult = ReturnType<typeof useCloneMenuMutation>;
export type CloneMenuMutationResult = Apollo.MutationResult<CloneMenuMutation>;
export type CloneMenuMutationOptions = Apollo.BaseMutationOptions<CloneMenuMutation, CloneMenuMutationVariables>;
export const GetMenuItemsDocument = gql`
    query GetMenuItems($companyId: Int!, $page: Int, $itemsPerPage: Int, $sortBy: String, $order: String, $id: Int, $search: String, $menuCategoryId: Int, $isDeleted: Boolean, $locale: String) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      id
      currency {
        currencySign
      }
      menuItems(
        page: $page
        itemsPerPage: $itemsPerPage
        sortBy: $sortBy
        order: $order
        id: $id
        search: $search
        menuCategoryId: $menuCategoryId
        isDeleted: $isDeleted
        locale: $locale
      ) {
        items {
          id
          menus {
            id
            name
            deleted
            branch {
              address
              country {
                id
                continentName
                isInEuropeanUnion
                isoCode
                localeCode
                name
              }
              currencyCode
              deleted
              id
              name
              onlineRegistration
              removedOfTariff
              timeZone
            }
            numberOfCategories
            numberOfItems
            numberOfItems
            status {
              id
              name
              slug
            }
            type {
              id
              name
              slug
            }
          }
          company {
            id
            name
            address
            phone
            deleted
          }
          favicon
          name(locale: $locale)
          nameOrigin
          description(locale: $locale)
          descriptionOrigin
          composition(locale: $locale)
          compositionOrigin
          unit {
            id
            name
          }
          isLongCookingTime
          deleted
          portions {
            id
            name(locale: $locale)
            nameOrigin
            volume
            price
            item {
              id
              name(locale: $locale)
              nameOrigin
              unit {
                id
                name
              }
              isLongCookingTime
              deleted
              company {
                id
                name
                address
                phone
                deleted
              }
            }
          }
          categories {
            id
            name(locale: $locale)
            nameOrigin
            comment(locale: $locale)
            descriptionOrigin
            favicon {
              id
              isDefault
              path
            }
            numberOfItems
            deleted
            parentCategory {
              id
              name(locale: $locale)
              nameOrigin
              comment(locale: $locale)
              descriptionOrigin
              favicon {
                id
                path
                isDefault
              }
              numberOfItems
              deleted
              company {
                id
                name
                address
                phone
                deleted
              }
              childCategories {
                id
                name(locale: $locale)
                nameOrigin
                comment(locale: $locale)
                descriptionOrigin
                favicon {
                  id
                  isDefault
                  path
                }
                numberOfItems
                deleted
                company {
                  id
                  name
                  address
                  phone
                  deleted
                }
              }
            }
            company {
              id
              name
              address
              phone
              deleted
            }
          }
        }
        totalCount
        currentPage
        itemsPerPage
        pageCount
      }
    }
  }
}
    `;

/**
 * __useGetMenuItemsQuery__
 *
 * To run a query within a React component, call `useGetMenuItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuItemsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      sortBy: // value for 'sortBy'
 *      order: // value for 'order'
 *      id: // value for 'id'
 *      search: // value for 'search'
 *      menuCategoryId: // value for 'menuCategoryId'
 *      isDeleted: // value for 'isDeleted'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetMenuItemsQuery(baseOptions: Apollo.QueryHookOptions<GetMenuItemsQuery, GetMenuItemsQueryVariables> & ({ variables: GetMenuItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuItemsQuery, GetMenuItemsQueryVariables>(GetMenuItemsDocument, options);
      }
export function useGetMenuItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuItemsQuery, GetMenuItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuItemsQuery, GetMenuItemsQueryVariables>(GetMenuItemsDocument, options);
        }
export function useGetMenuItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuItemsQuery, GetMenuItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuItemsQuery, GetMenuItemsQueryVariables>(GetMenuItemsDocument, options);
        }
export type GetMenuItemsQueryHookResult = ReturnType<typeof useGetMenuItemsQuery>;
export type GetMenuItemsLazyQueryHookResult = ReturnType<typeof useGetMenuItemsLazyQuery>;
export type GetMenuItemsSuspenseQueryHookResult = ReturnType<typeof useGetMenuItemsSuspenseQuery>;
export type GetMenuItemsQueryResult = Apollo.QueryResult<GetMenuItemsQuery, GetMenuItemsQueryVariables>;
export const GetMenuCategoriesDocument = gql`
    query GetMenuCategories($companyId: Int!, $page: Int, $itemsPerPage: Int, $id: Int, $search: String, $isDeleted: Boolean, $locale: String) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      id
      meMenuCategoriesPaginated(
        page: $page
        itemsPerPage: $itemsPerPage
        id: $id
        isDeleted: $isDeleted
        name: $search
        locale: $locale
      ) {
        categories {
          id
          name(locale: $locale)
          nameOrigin
          comment(locale: $locale)
          descriptionOrigin
          numberOfItems
          parentCategory {
            id
            name(locale: $locale)
            nameOrigin
            comment(locale: $locale)
            descriptionOrigin
            deleted
            numberOfItems
          }
          childCategories {
            id
            name(locale: $locale)
            nameOrigin
            comment(locale: $locale)
            descriptionOrigin
            deleted
            numberOfItems
            favicon {
              id
              path
              isDefault
            }
            parentCategory {
              id
              name(locale: $locale)
              nameOrigin
              deleted
              comment(locale: $locale)
              descriptionOrigin
              favicon {
                id
                isDefault
                path
              }
              numberOfItems
            }
          }
          deleted
          favicon {
            id
            path
            isDefault
          }
        }
        totalCount
        currentPage
        itemsPerPage
        pageCount
      }
    }
  }
}
    `;

/**
 * __useGetMenuCategoriesQuery__
 *
 * To run a query within a React component, call `useGetMenuCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuCategoriesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      id: // value for 'id'
 *      search: // value for 'search'
 *      isDeleted: // value for 'isDeleted'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetMenuCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetMenuCategoriesQuery, GetMenuCategoriesQueryVariables> & ({ variables: GetMenuCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuCategoriesQuery, GetMenuCategoriesQueryVariables>(GetMenuCategoriesDocument, options);
      }
export function useGetMenuCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuCategoriesQuery, GetMenuCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuCategoriesQuery, GetMenuCategoriesQueryVariables>(GetMenuCategoriesDocument, options);
        }
export function useGetMenuCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuCategoriesQuery, GetMenuCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuCategoriesQuery, GetMenuCategoriesQueryVariables>(GetMenuCategoriesDocument, options);
        }
export type GetMenuCategoriesQueryHookResult = ReturnType<typeof useGetMenuCategoriesQuery>;
export type GetMenuCategoriesLazyQueryHookResult = ReturnType<typeof useGetMenuCategoriesLazyQuery>;
export type GetMenuCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetMenuCategoriesSuspenseQuery>;
export type GetMenuCategoriesQueryResult = Apollo.QueryResult<GetMenuCategoriesQuery, GetMenuCategoriesQueryVariables>;
export const CreateMenuCategoryDocument = gql`
    mutation CreateMenuCategory($companyId: Int!, $input: MenuCategoryInput!, $branchId: Int!, $locale: String) {
  createMenuCategory(
    companyId: $companyId
    input: $input
    branchId: $branchId
    locale: $locale
  ) {
    id
    name(locale: $locale)
  }
}
    `;
export type CreateMenuCategoryMutationFn = Apollo.MutationFunction<CreateMenuCategoryMutation, CreateMenuCategoryMutationVariables>;

/**
 * __useCreateMenuCategoryMutation__
 *
 * To run a mutation, you first call `useCreateMenuCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMenuCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMenuCategoryMutation, { data, loading, error }] = useCreateMenuCategoryMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *      branchId: // value for 'branchId'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useCreateMenuCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateMenuCategoryMutation, CreateMenuCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMenuCategoryMutation, CreateMenuCategoryMutationVariables>(CreateMenuCategoryDocument, options);
      }
export type CreateMenuCategoryMutationHookResult = ReturnType<typeof useCreateMenuCategoryMutation>;
export type CreateMenuCategoryMutationResult = Apollo.MutationResult<CreateMenuCategoryMutation>;
export type CreateMenuCategoryMutationOptions = Apollo.BaseMutationOptions<CreateMenuCategoryMutation, CreateMenuCategoryMutationVariables>;
export const UpdateMenuCategoryDocument = gql`
    mutation UpdateMenuCategory($id: Int!, $companyId: Int!, $input: MenuCategoryInput!, $locale: String, $branchId: Int!) {
  updateMenuCategory(
    id: $id
    companyId: $companyId
    input: $input
    locale: $locale
    branchId: $branchId
  ) {
    id
    name(locale: $locale)
    deleted
  }
}
    `;
export type UpdateMenuCategoryMutationFn = Apollo.MutationFunction<UpdateMenuCategoryMutation, UpdateMenuCategoryMutationVariables>;

/**
 * __useUpdateMenuCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateMenuCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMenuCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMenuCategoryMutation, { data, loading, error }] = useUpdateMenuCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *      locale: // value for 'locale'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useUpdateMenuCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMenuCategoryMutation, UpdateMenuCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMenuCategoryMutation, UpdateMenuCategoryMutationVariables>(UpdateMenuCategoryDocument, options);
      }
export type UpdateMenuCategoryMutationHookResult = ReturnType<typeof useUpdateMenuCategoryMutation>;
export type UpdateMenuCategoryMutationResult = Apollo.MutationResult<UpdateMenuCategoryMutation>;
export type UpdateMenuCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateMenuCategoryMutation, UpdateMenuCategoryMutationVariables>;
export const DeleteMenuCategoryDocument = gql`
    mutation DeleteMenuCategory($branchId: Int!, $id: Int!) {
  deleteMenuCategory(branchId: $branchId, id: $id)
}
    `;
export type DeleteMenuCategoryMutationFn = Apollo.MutationFunction<DeleteMenuCategoryMutation, DeleteMenuCategoryMutationVariables>;

/**
 * __useDeleteMenuCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteMenuCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMenuCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMenuCategoryMutation, { data, loading, error }] = useDeleteMenuCategoryMutation({
 *   variables: {
 *      branchId: // value for 'branchId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMenuCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMenuCategoryMutation, DeleteMenuCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMenuCategoryMutation, DeleteMenuCategoryMutationVariables>(DeleteMenuCategoryDocument, options);
      }
export type DeleteMenuCategoryMutationHookResult = ReturnType<typeof useDeleteMenuCategoryMutation>;
export type DeleteMenuCategoryMutationResult = Apollo.MutationResult<DeleteMenuCategoryMutation>;
export type DeleteMenuCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteMenuCategoryMutation, DeleteMenuCategoryMutationVariables>;
export const RestoreMenuCategoryDocument = gql`
    mutation RestoreMenuCategory($branchId: Int!, $id: Int!) {
  restoreMenuCategory(branchId: $branchId, id: $id)
}
    `;
export type RestoreMenuCategoryMutationFn = Apollo.MutationFunction<RestoreMenuCategoryMutation, RestoreMenuCategoryMutationVariables>;

/**
 * __useRestoreMenuCategoryMutation__
 *
 * To run a mutation, you first call `useRestoreMenuCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreMenuCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreMenuCategoryMutation, { data, loading, error }] = useRestoreMenuCategoryMutation({
 *   variables: {
 *      branchId: // value for 'branchId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreMenuCategoryMutation(baseOptions?: Apollo.MutationHookOptions<RestoreMenuCategoryMutation, RestoreMenuCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreMenuCategoryMutation, RestoreMenuCategoryMutationVariables>(RestoreMenuCategoryDocument, options);
      }
export type RestoreMenuCategoryMutationHookResult = ReturnType<typeof useRestoreMenuCategoryMutation>;
export type RestoreMenuCategoryMutationResult = Apollo.MutationResult<RestoreMenuCategoryMutation>;
export type RestoreMenuCategoryMutationOptions = Apollo.BaseMutationOptions<RestoreMenuCategoryMutation, RestoreMenuCategoryMutationVariables>;
export const GetCurrentMenuItemDocument = gql`
    query GetCurrentMenuItem($id: Int, $companyId: Int!, $locale: String) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      id
      menuItems(id: $id) {
        items {
          id
          name(locale: $locale)
          nameOrigin
          deleted
          favicon
          types {
            id
            name
            slug
          }
          unit {
            id
            name
          }
          portions {
            id
            name(locale: $locale)
            nameOrigin
            volume
            price
            item {
              id
              name(locale: $locale)
              nameOrigin
              unit {
                id
                name
              }
              isLongCookingTime
              deleted
              company {
                id
                name
                phone
                deleted
              }
            }
          }
          categories {
            id
            name(locale: $locale)
            nameOrigin
            comment(locale: $locale)
            descriptionOrigin
            favicon {
              id
              isDefault
              path
            }
            numberOfItems
            deleted
            parentCategory {
              id
              name(locale: $locale)
              nameOrigin
              comment(locale: $locale)
              descriptionOrigin
              favicon {
                id
                isDefault
                path
              }
              numberOfItems
              deleted
              company {
                id
                name
                phone
                deleted
              }
              childCategories {
                id
                name(locale: $locale)
                nameOrigin
                comment(locale: $locale)
                descriptionOrigin
                favicon {
                  id
                  isDefault
                  path
                }
                numberOfItems
                deleted
                company {
                  id
                  name
                  phone
                  deleted
                }
              }
            }
            company {
              id
              name
              phone
              deleted
            }
          }
          description(locale: $locale)
          descriptionOrigin
          composition(locale: $locale)
          compositionOrigin
          cookingTime
          isLongCookingTime
          markers {
            id
            name
            slug
          }
          allergens {
            id
            name
            slug
          }
          company {
            id
            name
            phone
            deleted
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCurrentMenuItemQuery__
 *
 * To run a query within a React component, call `useGetCurrentMenuItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentMenuItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentMenuItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetCurrentMenuItemQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentMenuItemQuery, GetCurrentMenuItemQueryVariables> & ({ variables: GetCurrentMenuItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentMenuItemQuery, GetCurrentMenuItemQueryVariables>(GetCurrentMenuItemDocument, options);
      }
export function useGetCurrentMenuItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentMenuItemQuery, GetCurrentMenuItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentMenuItemQuery, GetCurrentMenuItemQueryVariables>(GetCurrentMenuItemDocument, options);
        }
export function useGetCurrentMenuItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentMenuItemQuery, GetCurrentMenuItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentMenuItemQuery, GetCurrentMenuItemQueryVariables>(GetCurrentMenuItemDocument, options);
        }
export type GetCurrentMenuItemQueryHookResult = ReturnType<typeof useGetCurrentMenuItemQuery>;
export type GetCurrentMenuItemLazyQueryHookResult = ReturnType<typeof useGetCurrentMenuItemLazyQuery>;
export type GetCurrentMenuItemSuspenseQueryHookResult = ReturnType<typeof useGetCurrentMenuItemSuspenseQuery>;
export type GetCurrentMenuItemQueryResult = Apollo.QueryResult<GetCurrentMenuItemQuery, GetCurrentMenuItemQueryVariables>;
export const GetMenuAllergensDocument = gql`
    query GetMenuAllergens {
  menuAllergens {
    id
    name
    slug
  }
}
    `;

/**
 * __useGetMenuAllergensQuery__
 *
 * To run a query within a React component, call `useGetMenuAllergensQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuAllergensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuAllergensQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMenuAllergensQuery(baseOptions?: Apollo.QueryHookOptions<GetMenuAllergensQuery, GetMenuAllergensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuAllergensQuery, GetMenuAllergensQueryVariables>(GetMenuAllergensDocument, options);
      }
export function useGetMenuAllergensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuAllergensQuery, GetMenuAllergensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuAllergensQuery, GetMenuAllergensQueryVariables>(GetMenuAllergensDocument, options);
        }
export function useGetMenuAllergensSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuAllergensQuery, GetMenuAllergensQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuAllergensQuery, GetMenuAllergensQueryVariables>(GetMenuAllergensDocument, options);
        }
export type GetMenuAllergensQueryHookResult = ReturnType<typeof useGetMenuAllergensQuery>;
export type GetMenuAllergensLazyQueryHookResult = ReturnType<typeof useGetMenuAllergensLazyQuery>;
export type GetMenuAllergensSuspenseQueryHookResult = ReturnType<typeof useGetMenuAllergensSuspenseQuery>;
export type GetMenuAllergensQueryResult = Apollo.QueryResult<GetMenuAllergensQuery, GetMenuAllergensQueryVariables>;
export const GetMenuTypesDocument = gql`
    query GetMenuTypes {
  menuTypes {
    id
    name
    slug
  }
}
    `;

/**
 * __useGetMenuTypesQuery__
 *
 * To run a query within a React component, call `useGetMenuTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMenuTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetMenuTypesQuery, GetMenuTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuTypesQuery, GetMenuTypesQueryVariables>(GetMenuTypesDocument, options);
      }
export function useGetMenuTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuTypesQuery, GetMenuTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuTypesQuery, GetMenuTypesQueryVariables>(GetMenuTypesDocument, options);
        }
export function useGetMenuTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuTypesQuery, GetMenuTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuTypesQuery, GetMenuTypesQueryVariables>(GetMenuTypesDocument, options);
        }
export type GetMenuTypesQueryHookResult = ReturnType<typeof useGetMenuTypesQuery>;
export type GetMenuTypesLazyQueryHookResult = ReturnType<typeof useGetMenuTypesLazyQuery>;
export type GetMenuTypesSuspenseQueryHookResult = ReturnType<typeof useGetMenuTypesSuspenseQuery>;
export type GetMenuTypesQueryResult = Apollo.QueryResult<GetMenuTypesQuery, GetMenuTypesQueryVariables>;
export const GetMenuMarkersDocument = gql`
    query GetMenuMarkers {
  menuMarkers {
    id
    name
    slug
  }
}
    `;

/**
 * __useGetMenuMarkersQuery__
 *
 * To run a query within a React component, call `useGetMenuMarkersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuMarkersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuMarkersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMenuMarkersQuery(baseOptions?: Apollo.QueryHookOptions<GetMenuMarkersQuery, GetMenuMarkersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuMarkersQuery, GetMenuMarkersQueryVariables>(GetMenuMarkersDocument, options);
      }
export function useGetMenuMarkersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuMarkersQuery, GetMenuMarkersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuMarkersQuery, GetMenuMarkersQueryVariables>(GetMenuMarkersDocument, options);
        }
export function useGetMenuMarkersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuMarkersQuery, GetMenuMarkersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuMarkersQuery, GetMenuMarkersQueryVariables>(GetMenuMarkersDocument, options);
        }
export type GetMenuMarkersQueryHookResult = ReturnType<typeof useGetMenuMarkersQuery>;
export type GetMenuMarkersLazyQueryHookResult = ReturnType<typeof useGetMenuMarkersLazyQuery>;
export type GetMenuMarkersSuspenseQueryHookResult = ReturnType<typeof useGetMenuMarkersSuspenseQuery>;
export type GetMenuMarkersQueryResult = Apollo.QueryResult<GetMenuMarkersQuery, GetMenuMarkersQueryVariables>;
export const GetMenuStatusesDocument = gql`
    query GetMenuStatuses {
  menuStatuses {
    id
    name
    slug
  }
}
    `;

/**
 * __useGetMenuStatusesQuery__
 *
 * To run a query within a React component, call `useGetMenuStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMenuStatusesQuery(baseOptions?: Apollo.QueryHookOptions<GetMenuStatusesQuery, GetMenuStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuStatusesQuery, GetMenuStatusesQueryVariables>(GetMenuStatusesDocument, options);
      }
export function useGetMenuStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuStatusesQuery, GetMenuStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuStatusesQuery, GetMenuStatusesQueryVariables>(GetMenuStatusesDocument, options);
        }
export function useGetMenuStatusesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuStatusesQuery, GetMenuStatusesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuStatusesQuery, GetMenuStatusesQueryVariables>(GetMenuStatusesDocument, options);
        }
export type GetMenuStatusesQueryHookResult = ReturnType<typeof useGetMenuStatusesQuery>;
export type GetMenuStatusesLazyQueryHookResult = ReturnType<typeof useGetMenuStatusesLazyQuery>;
export type GetMenuStatusesSuspenseQueryHookResult = ReturnType<typeof useGetMenuStatusesSuspenseQuery>;
export type GetMenuStatusesQueryResult = Apollo.QueryResult<GetMenuStatusesQuery, GetMenuStatusesQueryVariables>;
export const GetMenuUnitsDocument = gql`
    query GetMenuUnits {
  relations {
    units {
      id
      name
    }
  }
}
    `;

/**
 * __useGetMenuUnitsQuery__
 *
 * To run a query within a React component, call `useGetMenuUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuUnitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMenuUnitsQuery(baseOptions?: Apollo.QueryHookOptions<GetMenuUnitsQuery, GetMenuUnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuUnitsQuery, GetMenuUnitsQueryVariables>(GetMenuUnitsDocument, options);
      }
export function useGetMenuUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuUnitsQuery, GetMenuUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuUnitsQuery, GetMenuUnitsQueryVariables>(GetMenuUnitsDocument, options);
        }
export function useGetMenuUnitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuUnitsQuery, GetMenuUnitsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuUnitsQuery, GetMenuUnitsQueryVariables>(GetMenuUnitsDocument, options);
        }
export type GetMenuUnitsQueryHookResult = ReturnType<typeof useGetMenuUnitsQuery>;
export type GetMenuUnitsLazyQueryHookResult = ReturnType<typeof useGetMenuUnitsLazyQuery>;
export type GetMenuUnitsSuspenseQueryHookResult = ReturnType<typeof useGetMenuUnitsSuspenseQuery>;
export type GetMenuUnitsQueryResult = Apollo.QueryResult<GetMenuUnitsQuery, GetMenuUnitsQueryVariables>;
export const GetMenuCategoriesIconsDocument = gql`
    query GetMenuCategoriesIcons($companyId: Int!) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      menuCategoryIconList {
        id
        path
        isDefault
      }
    }
  }
}
    `;

/**
 * __useGetMenuCategoriesIconsQuery__
 *
 * To run a query within a React component, call `useGetMenuCategoriesIconsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuCategoriesIconsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuCategoriesIconsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetMenuCategoriesIconsQuery(baseOptions: Apollo.QueryHookOptions<GetMenuCategoriesIconsQuery, GetMenuCategoriesIconsQueryVariables> & ({ variables: GetMenuCategoriesIconsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuCategoriesIconsQuery, GetMenuCategoriesIconsQueryVariables>(GetMenuCategoriesIconsDocument, options);
      }
export function useGetMenuCategoriesIconsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuCategoriesIconsQuery, GetMenuCategoriesIconsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuCategoriesIconsQuery, GetMenuCategoriesIconsQueryVariables>(GetMenuCategoriesIconsDocument, options);
        }
export function useGetMenuCategoriesIconsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuCategoriesIconsQuery, GetMenuCategoriesIconsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuCategoriesIconsQuery, GetMenuCategoriesIconsQueryVariables>(GetMenuCategoriesIconsDocument, options);
        }
export type GetMenuCategoriesIconsQueryHookResult = ReturnType<typeof useGetMenuCategoriesIconsQuery>;
export type GetMenuCategoriesIconsLazyQueryHookResult = ReturnType<typeof useGetMenuCategoriesIconsLazyQuery>;
export type GetMenuCategoriesIconsSuspenseQueryHookResult = ReturnType<typeof useGetMenuCategoriesIconsSuspenseQuery>;
export type GetMenuCategoriesIconsQueryResult = Apollo.QueryResult<GetMenuCategoriesIconsQuery, GetMenuCategoriesIconsQueryVariables>;
export const GetMenuPageDocument = gql`
    query GetMenuPage($page: Int, $itemsPerPage: Int, $id: Int, $search: String, $menuTypeId: Int, $isDeleted: Boolean, $companyId: Int) {
  user(companyId: $companyId) {
    currentBranch {
      menus(
        page: $page
        itemsPerPage: $itemsPerPage
        id: $id
        search: $search
        menuTypeId: $menuTypeId
        isDeleted: $isDeleted
      ) {
        menus {
          id
          branch {
            id
            country {
              id
            }
          }
          name
          type {
            id
          }
          status {
            id
            name
            slug
          }
          numberOfCategories
          numberOfItems
          categoryRelations {
            id
          }
          deleted
        }
        totalCount
        currentPage
        itemsPerPage
        pageCount
      }
    }
  }
}
    `;

/**
 * __useGetMenuPageQuery__
 *
 * To run a query within a React component, call `useGetMenuPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuPageQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      id: // value for 'id'
 *      search: // value for 'search'
 *      menuTypeId: // value for 'menuTypeId'
 *      isDeleted: // value for 'isDeleted'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetMenuPageQuery(baseOptions?: Apollo.QueryHookOptions<GetMenuPageQuery, GetMenuPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuPageQuery, GetMenuPageQueryVariables>(GetMenuPageDocument, options);
      }
export function useGetMenuPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuPageQuery, GetMenuPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuPageQuery, GetMenuPageQueryVariables>(GetMenuPageDocument, options);
        }
export function useGetMenuPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMenuPageQuery, GetMenuPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMenuPageQuery, GetMenuPageQueryVariables>(GetMenuPageDocument, options);
        }
export type GetMenuPageQueryHookResult = ReturnType<typeof useGetMenuPageQuery>;
export type GetMenuPageLazyQueryHookResult = ReturnType<typeof useGetMenuPageLazyQuery>;
export type GetMenuPageSuspenseQueryHookResult = ReturnType<typeof useGetMenuPageSuspenseQuery>;
export type GetMenuPageQueryResult = Apollo.QueryResult<GetMenuPageQuery, GetMenuPageQueryVariables>;
export const GetCurrencyMenuItemDocument = gql`
    query GetCurrencyMenuItem($companyId: Int!) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      id
      currency {
        id
        currency
        code
        currencySign
      }
    }
  }
}
    `;

/**
 * __useGetCurrencyMenuItemQuery__
 *
 * To run a query within a React component, call `useGetCurrencyMenuItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrencyMenuItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrencyMenuItemQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCurrencyMenuItemQuery(baseOptions: Apollo.QueryHookOptions<GetCurrencyMenuItemQuery, GetCurrencyMenuItemQueryVariables> & ({ variables: GetCurrencyMenuItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrencyMenuItemQuery, GetCurrencyMenuItemQueryVariables>(GetCurrencyMenuItemDocument, options);
      }
export function useGetCurrencyMenuItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrencyMenuItemQuery, GetCurrencyMenuItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrencyMenuItemQuery, GetCurrencyMenuItemQueryVariables>(GetCurrencyMenuItemDocument, options);
        }
export function useGetCurrencyMenuItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrencyMenuItemQuery, GetCurrencyMenuItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrencyMenuItemQuery, GetCurrencyMenuItemQueryVariables>(GetCurrencyMenuItemDocument, options);
        }
export type GetCurrencyMenuItemQueryHookResult = ReturnType<typeof useGetCurrencyMenuItemQuery>;
export type GetCurrencyMenuItemLazyQueryHookResult = ReturnType<typeof useGetCurrencyMenuItemLazyQuery>;
export type GetCurrencyMenuItemSuspenseQueryHookResult = ReturnType<typeof useGetCurrencyMenuItemSuspenseQuery>;
export type GetCurrencyMenuItemQueryResult = Apollo.QueryResult<GetCurrencyMenuItemQuery, GetCurrencyMenuItemQueryVariables>;
export const GetLinkAndQrCodeMenuDocument = gql`
    query GetLinkAndQrCodeMenu($companyId: Int!, $branchId: Int, $menuId: Int, $menusListId: Int) {
  user {
    company(id: $companyId) {
      branches(id: $branchId) {
        menusList(id: $menusListId) {
          id
          name
          status {
            id
            name
            slug
          }
          type {
            id
            name
            slug
          }
          languages {
            id
            name
          }
          qrMenuLink(menuId: $menuId)
          qrMenuQrCode(menuId: $menuId)
        }
      }
    }
  }
}
    `;

/**
 * __useGetLinkAndQrCodeMenuQuery__
 *
 * To run a query within a React component, call `useGetLinkAndQrCodeMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkAndQrCodeMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkAndQrCodeMenuQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *      menuId: // value for 'menuId'
 *      menusListId: // value for 'menusListId'
 *   },
 * });
 */
export function useGetLinkAndQrCodeMenuQuery(baseOptions: Apollo.QueryHookOptions<GetLinkAndQrCodeMenuQuery, GetLinkAndQrCodeMenuQueryVariables> & ({ variables: GetLinkAndQrCodeMenuQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLinkAndQrCodeMenuQuery, GetLinkAndQrCodeMenuQueryVariables>(GetLinkAndQrCodeMenuDocument, options);
      }
export function useGetLinkAndQrCodeMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLinkAndQrCodeMenuQuery, GetLinkAndQrCodeMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLinkAndQrCodeMenuQuery, GetLinkAndQrCodeMenuQueryVariables>(GetLinkAndQrCodeMenuDocument, options);
        }
export function useGetLinkAndQrCodeMenuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLinkAndQrCodeMenuQuery, GetLinkAndQrCodeMenuQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLinkAndQrCodeMenuQuery, GetLinkAndQrCodeMenuQueryVariables>(GetLinkAndQrCodeMenuDocument, options);
        }
export type GetLinkAndQrCodeMenuQueryHookResult = ReturnType<typeof useGetLinkAndQrCodeMenuQuery>;
export type GetLinkAndQrCodeMenuLazyQueryHookResult = ReturnType<typeof useGetLinkAndQrCodeMenuLazyQuery>;
export type GetLinkAndQrCodeMenuSuspenseQueryHookResult = ReturnType<typeof useGetLinkAndQrCodeMenuSuspenseQuery>;
export type GetLinkAndQrCodeMenuQueryResult = Apollo.QueryResult<GetLinkAndQrCodeMenuQuery, GetLinkAndQrCodeMenuQueryVariables>;
export const GetOneMenuDocument = gql`
    query getOneMenu($companyId: Int!, $branchId: Int, $menuId: Int) {
  user {
    company(id: $companyId) {
      branches(id: $branchId) {
        menusList(id: $menuId) {
          name
          status {
            id
            name
            slug
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetOneMenuQuery__
 *
 * To run a query within a React component, call `useGetOneMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOneMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOneMenuQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *      menuId: // value for 'menuId'
 *   },
 * });
 */
export function useGetOneMenuQuery(baseOptions: Apollo.QueryHookOptions<GetOneMenuQuery, GetOneMenuQueryVariables> & ({ variables: GetOneMenuQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOneMenuQuery, GetOneMenuQueryVariables>(GetOneMenuDocument, options);
      }
export function useGetOneMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOneMenuQuery, GetOneMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOneMenuQuery, GetOneMenuQueryVariables>(GetOneMenuDocument, options);
        }
export function useGetOneMenuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOneMenuQuery, GetOneMenuQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOneMenuQuery, GetOneMenuQueryVariables>(GetOneMenuDocument, options);
        }
export type GetOneMenuQueryHookResult = ReturnType<typeof useGetOneMenuQuery>;
export type GetOneMenuLazyQueryHookResult = ReturnType<typeof useGetOneMenuLazyQuery>;
export type GetOneMenuSuspenseQueryHookResult = ReturnType<typeof useGetOneMenuSuspenseQuery>;
export type GetOneMenuQueryResult = Apollo.QueryResult<GetOneMenuQuery, GetOneMenuQueryVariables>;
export const GetActiveMenusByTypeDocument = gql`
    query getActiveMenusByType($companyId: Int!, $branchId: Int) {
  user {
    company(id: $companyId) {
      branches(id: $branchId) {
        activeDeliveryMenu {
          id
          name
          qrMenuLink
          qrMenuQrCode
          type {
            id
            name
            slug
          }
          status {
            id
            name
            slug
          }
          languages {
            id
            name
          }
        }
        activeDineInMenu {
          id
          name
          qrMenuLink
          qrMenuQrCode
          type {
            id
            name
            slug
          }
          status {
            id
            name
            slug
          }
          languages {
            id
            name
          }
        }
        activePickUpMenu {
          id
          name
          qrMenuLink
          qrMenuQrCode
          type {
            id
            name
            slug
          }
          status {
            id
            name
            slug
          }
          languages {
            id
            name
          }
        }
        replaceableDineInMenus {
          id
          name
          type {
            id
            name
            slug
          }
          status {
            id
            name
            slug
          }
          languages {
            id
            name
          }
        }
        replaceableDeliveryMenus {
          id
          name
          type {
            id
            name
            slug
          }
          status {
            id
            name
            slug
          }
          languages {
            id
            name
          }
        }
        replaceablePickUpMenus {
          id
          name
          type {
            id
            name
            slug
          }
          status {
            id
            name
            slug
          }
          languages {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetActiveMenusByTypeQuery__
 *
 * To run a query within a React component, call `useGetActiveMenusByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveMenusByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveMenusByTypeQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useGetActiveMenusByTypeQuery(baseOptions: Apollo.QueryHookOptions<GetActiveMenusByTypeQuery, GetActiveMenusByTypeQueryVariables> & ({ variables: GetActiveMenusByTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveMenusByTypeQuery, GetActiveMenusByTypeQueryVariables>(GetActiveMenusByTypeDocument, options);
      }
export function useGetActiveMenusByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveMenusByTypeQuery, GetActiveMenusByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveMenusByTypeQuery, GetActiveMenusByTypeQueryVariables>(GetActiveMenusByTypeDocument, options);
        }
export function useGetActiveMenusByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveMenusByTypeQuery, GetActiveMenusByTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveMenusByTypeQuery, GetActiveMenusByTypeQueryVariables>(GetActiveMenusByTypeDocument, options);
        }
export type GetActiveMenusByTypeQueryHookResult = ReturnType<typeof useGetActiveMenusByTypeQuery>;
export type GetActiveMenusByTypeLazyQueryHookResult = ReturnType<typeof useGetActiveMenusByTypeLazyQuery>;
export type GetActiveMenusByTypeSuspenseQueryHookResult = ReturnType<typeof useGetActiveMenusByTypeSuspenseQuery>;
export type GetActiveMenusByTypeQueryResult = Apollo.QueryResult<GetActiveMenusByTypeQuery, GetActiveMenusByTypeQueryVariables>;
export const GetCategoriesForMoveCategoryModalDocument = gql`
    query GetCategoriesForMoveCategoryModal($companyId: Int!, $locale: String) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      id
      meMenuCategories(onlyTopLevel: true, deleted: false) {
        id
        name(locale: $locale)
        nameOrigin
        childCategories(deleted: false) {
          id
          name(locale: $locale)
          nameOrigin
        }
      }
    }
  }
}
    `;

/**
 * __useGetCategoriesForMoveCategoryModalQuery__
 *
 * To run a query within a React component, call `useGetCategoriesForMoveCategoryModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesForMoveCategoryModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesForMoveCategoryModalQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetCategoriesForMoveCategoryModalQuery(baseOptions: Apollo.QueryHookOptions<GetCategoriesForMoveCategoryModalQuery, GetCategoriesForMoveCategoryModalQueryVariables> & ({ variables: GetCategoriesForMoveCategoryModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesForMoveCategoryModalQuery, GetCategoriesForMoveCategoryModalQueryVariables>(GetCategoriesForMoveCategoryModalDocument, options);
      }
export function useGetCategoriesForMoveCategoryModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesForMoveCategoryModalQuery, GetCategoriesForMoveCategoryModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesForMoveCategoryModalQuery, GetCategoriesForMoveCategoryModalQueryVariables>(GetCategoriesForMoveCategoryModalDocument, options);
        }
export function useGetCategoriesForMoveCategoryModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoriesForMoveCategoryModalQuery, GetCategoriesForMoveCategoryModalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoriesForMoveCategoryModalQuery, GetCategoriesForMoveCategoryModalQueryVariables>(GetCategoriesForMoveCategoryModalDocument, options);
        }
export type GetCategoriesForMoveCategoryModalQueryHookResult = ReturnType<typeof useGetCategoriesForMoveCategoryModalQuery>;
export type GetCategoriesForMoveCategoryModalLazyQueryHookResult = ReturnType<typeof useGetCategoriesForMoveCategoryModalLazyQuery>;
export type GetCategoriesForMoveCategoryModalSuspenseQueryHookResult = ReturnType<typeof useGetCategoriesForMoveCategoryModalSuspenseQuery>;
export type GetCategoriesForMoveCategoryModalQueryResult = Apollo.QueryResult<GetCategoriesForMoveCategoryModalQuery, GetCategoriesForMoveCategoryModalQueryVariables>;
export const UpdateMenuStatusDocument = gql`
    mutation UpdateMenuStatus($menuId: Int!, $branchId: Int!, $input: MenuInput!, $ignoreValidation: Boolean!) {
  updateMenuStatus(
    menuId: $menuId
    branchId: $branchId
    input: $input
    ignoreValidation: $ignoreValidation
  ) {
    id
  }
}
    `;
export type UpdateMenuStatusMutationFn = Apollo.MutationFunction<UpdateMenuStatusMutation, UpdateMenuStatusMutationVariables>;

/**
 * __useUpdateMenuStatusMutation__
 *
 * To run a mutation, you first call `useUpdateMenuStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMenuStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMenuStatusMutation, { data, loading, error }] = useUpdateMenuStatusMutation({
 *   variables: {
 *      menuId: // value for 'menuId'
 *      branchId: // value for 'branchId'
 *      input: // value for 'input'
 *      ignoreValidation: // value for 'ignoreValidation'
 *   },
 * });
 */
export function useUpdateMenuStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMenuStatusMutation, UpdateMenuStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMenuStatusMutation, UpdateMenuStatusMutationVariables>(UpdateMenuStatusDocument, options);
      }
export type UpdateMenuStatusMutationHookResult = ReturnType<typeof useUpdateMenuStatusMutation>;
export type UpdateMenuStatusMutationResult = Apollo.MutationResult<UpdateMenuStatusMutation>;
export type UpdateMenuStatusMutationOptions = Apollo.BaseMutationOptions<UpdateMenuStatusMutation, UpdateMenuStatusMutationVariables>;
export type GetMenuListQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  menuTypeId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetMenuListQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', branchesPaginated?: { __typename?: 'BranchPaginated', branches?: Array<{ __typename?: 'BranchProxy', menus?: { __typename?: 'MenuPaginated', totalCount?: number | null, currentPage?: number | null, itemsPerPage?: number | null, pageCount?: string | null, menus?: Array<{ __typename?: 'MenuProxy', id: number, name: string, numberOfCategories: number, numberOfItems: number, deleted: boolean, type: { __typename?: 'MenuTypeProxy', id: number, name: string, slug: string }, status: { __typename?: 'MenuStatusProxy', id: number, name: string, slug: string }, languages?: Array<{ __typename?: 'LanguageProxy', id: number, name: string }> | null, primaryLanguage?: { __typename?: 'LanguageProxy', id: number, name: string } | null }> | null } | null }> | null } | null } | null } | null };

export type MenuTypesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MenuTypesQuery = { __typename?: 'Query', menuTypes: Array<{ __typename?: 'MenuTypeProxy', id: number, name: string, slug: string }> };

export type GetLanguageVersionsQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetLanguageVersionsQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', languages?: Array<{ __typename?: 'LanguageProxy', id: number, name: string, isoCode: string }> | null, primaryLanguage?: { __typename?: 'LanguageProxy', id: number, name: string, isoCode: string } | null } | null } | null };

export type CreateMenuMutationVariables = Types.Exact<{
  branchId: Types.Scalars['Int']['input'];
  input: Types.MenuInput;
}>;


export type CreateMenuMutation = { __typename?: 'Mutation', createMenu: { __typename?: 'MenuProxy', id: number } };

export type UpdateMenuMutationVariables = Types.Exact<{
  menuId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
  input: Types.MenuInput;
  allowArchive?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type UpdateMenuMutation = { __typename?: 'Mutation', updateMenu: { __typename?: 'MenuProxy', id: number } };

export type DeleteMenuMutationVariables = Types.Exact<{
  branchId: Types.Scalars['Int']['input'];
  id: Types.Scalars['Int']['input'];
}>;


export type DeleteMenuMutation = { __typename?: 'Mutation', deleteMenu: boolean };

export type RestoreMenuMutationVariables = Types.Exact<{
  branchId: Types.Scalars['Int']['input'];
  id: Types.Scalars['Int']['input'];
}>;


export type RestoreMenuMutation = { __typename?: 'Mutation', restoreMenu: boolean };

export type CloneMenuMutationVariables = Types.Exact<{
  cloneMenuId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
  input: Types.MenuInput;
}>;


export type CloneMenuMutation = { __typename?: 'Mutation', cloneMenu: { __typename?: 'MenuProxy', id: number } };

export type GetMenuItemsQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  sortBy?: Types.InputMaybe<Types.Scalars['String']['input']>;
  order?: Types.InputMaybe<Types.Scalars['String']['input']>;
  id?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  menuCategoryId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  isDeleted?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetMenuItemsQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, currency?: { __typename?: 'CurrencyProxy', currencySign?: string | null } | null, menuItems?: { __typename?: 'MenuItemPaginated', totalCount?: number | null, currentPage?: number | null, itemsPerPage?: number | null, pageCount?: string | null, items?: Array<{ __typename?: 'MenuItemProxy', id: number, favicon?: string | null, name?: string | null, nameOrigin?: string | null, description?: string | null, descriptionOrigin?: string | null, composition?: string | null, compositionOrigin?: string | null, isLongCookingTime: boolean, deleted: boolean, menus?: Array<{ __typename?: 'MenuProxy', id: number, name: string, deleted: boolean, numberOfCategories: number, numberOfItems: number, branch: { __typename?: 'BranchProxy', address: string, currencyCode: string, deleted: boolean, id: number, name: string, onlineRegistration: boolean, removedOfTariff: boolean, timeZone: string, country: { __typename?: 'Country', id: string, continentName: string, isInEuropeanUnion: boolean, isoCode: string, localeCode: string, name: string } }, status: { __typename?: 'MenuStatusProxy', id: number, name: string, slug: string }, type: { __typename?: 'MenuTypeProxy', id: number, name: string, slug: string } }> | null, company: { __typename?: 'CompanyProxy', id: number, name: string, address: string, phone: string, deleted: boolean }, unit: { __typename?: 'UnitProxy', id: number, name: string }, portions?: Array<{ __typename?: 'MenuItemPortionProxy', id: number, name?: string | null, nameOrigin?: string | null, volume: number, price: number, item: { __typename?: 'MenuItemProxy', id: number, name?: string | null, nameOrigin?: string | null, isLongCookingTime: boolean, deleted: boolean, unit: { __typename?: 'UnitProxy', id: number, name: string }, company: { __typename?: 'CompanyProxy', id: number, name: string, address: string, phone: string, deleted: boolean } } }> | null, categories?: Array<{ __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, comment?: string | null, descriptionOrigin?: string | null, numberOfItems: number, deleted: boolean, favicon?: { __typename?: 'MenuCategoryIconProxy', id: number, isDefault: boolean, path?: string | null } | null, parentCategory?: { __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, comment?: string | null, descriptionOrigin?: string | null, numberOfItems: number, deleted: boolean, favicon?: { __typename?: 'MenuCategoryIconProxy', id: number, path?: string | null, isDefault: boolean } | null, company: { __typename?: 'CompanyProxy', id: number, name: string, address: string, phone: string, deleted: boolean }, childCategories?: Array<{ __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, comment?: string | null, descriptionOrigin?: string | null, numberOfItems: number, deleted: boolean, favicon?: { __typename?: 'MenuCategoryIconProxy', id: number, isDefault: boolean, path?: string | null } | null, company: { __typename?: 'CompanyProxy', id: number, name: string, address: string, phone: string, deleted: boolean } }> | null } | null, company: { __typename?: 'CompanyProxy', id: number, name: string, address: string, phone: string, deleted: boolean } }> | null }> | null } | null } | null } | null };

export type GetMenuCategoriesQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  id?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  isDeleted?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetMenuCategoriesQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, meMenuCategoriesPaginated?: { __typename?: 'MenuCategoryPaginated', totalCount?: number | null, currentPage?: number | null, itemsPerPage?: number | null, pageCount?: string | null, categories?: Array<{ __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, comment?: string | null, descriptionOrigin?: string | null, numberOfItems: number, deleted: boolean, parentCategory?: { __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, comment?: string | null, descriptionOrigin?: string | null, deleted: boolean, numberOfItems: number } | null, childCategories?: Array<{ __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, comment?: string | null, descriptionOrigin?: string | null, deleted: boolean, numberOfItems: number, favicon?: { __typename?: 'MenuCategoryIconProxy', id: number, path?: string | null, isDefault: boolean } | null, parentCategory?: { __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, deleted: boolean, comment?: string | null, descriptionOrigin?: string | null, numberOfItems: number, favicon?: { __typename?: 'MenuCategoryIconProxy', id: number, isDefault: boolean, path?: string | null } | null } | null }> | null, favicon?: { __typename?: 'MenuCategoryIconProxy', id: number, path?: string | null, isDefault: boolean } | null }> | null } | null } | null } | null };

export type CreateMenuCategoryMutationVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  input: Types.MenuCategoryInput;
  branchId: Types.Scalars['Int']['input'];
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type CreateMenuCategoryMutation = { __typename?: 'Mutation', createMenuCategory: { __typename?: 'MenuCategoryProxy', id: number, name?: string | null } };

export type UpdateMenuCategoryMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  companyId: Types.Scalars['Int']['input'];
  input: Types.MenuCategoryInput;
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
  branchId: Types.Scalars['Int']['input'];
}>;


export type UpdateMenuCategoryMutation = { __typename?: 'Mutation', updateMenuCategory: { __typename?: 'MenuCategoryProxy', id: number, name?: string | null, deleted: boolean } };

export type DeleteMenuCategoryMutationVariables = Types.Exact<{
  branchId: Types.Scalars['Int']['input'];
  id: Types.Scalars['Int']['input'];
}>;


export type DeleteMenuCategoryMutation = { __typename?: 'Mutation', deleteMenuCategory: boolean };

export type RestoreMenuCategoryMutationVariables = Types.Exact<{
  branchId: Types.Scalars['Int']['input'];
  id: Types.Scalars['Int']['input'];
}>;


export type RestoreMenuCategoryMutation = { __typename?: 'Mutation', restoreMenuCategory: boolean };

export type GetCurrentMenuItemQueryVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  companyId: Types.Scalars['Int']['input'];
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCurrentMenuItemQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, menuItems?: { __typename?: 'MenuItemPaginated', items?: Array<{ __typename?: 'MenuItemProxy', id: number, name?: string | null, nameOrigin?: string | null, deleted: boolean, favicon?: string | null, description?: string | null, descriptionOrigin?: string | null, composition?: string | null, compositionOrigin?: string | null, cookingTime?: string | null, isLongCookingTime: boolean, types?: Array<{ __typename?: 'MenuTypeProxy', id: number, name: string, slug: string }> | null, unit: { __typename?: 'UnitProxy', id: number, name: string }, portions?: Array<{ __typename?: 'MenuItemPortionProxy', id: number, name?: string | null, nameOrigin?: string | null, volume: number, price: number, item: { __typename?: 'MenuItemProxy', id: number, name?: string | null, nameOrigin?: string | null, isLongCookingTime: boolean, deleted: boolean, unit: { __typename?: 'UnitProxy', id: number, name: string }, company: { __typename?: 'CompanyProxy', id: number, name: string, phone: string, deleted: boolean } } }> | null, categories?: Array<{ __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, comment?: string | null, descriptionOrigin?: string | null, numberOfItems: number, deleted: boolean, favicon?: { __typename?: 'MenuCategoryIconProxy', id: number, isDefault: boolean, path?: string | null } | null, parentCategory?: { __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, comment?: string | null, descriptionOrigin?: string | null, numberOfItems: number, deleted: boolean, favicon?: { __typename?: 'MenuCategoryIconProxy', id: number, isDefault: boolean, path?: string | null } | null, company: { __typename?: 'CompanyProxy', id: number, name: string, phone: string, deleted: boolean }, childCategories?: Array<{ __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, comment?: string | null, descriptionOrigin?: string | null, numberOfItems: number, deleted: boolean, favicon?: { __typename?: 'MenuCategoryIconProxy', id: number, isDefault: boolean, path?: string | null } | null, company: { __typename?: 'CompanyProxy', id: number, name: string, phone: string, deleted: boolean } }> | null } | null, company: { __typename?: 'CompanyProxy', id: number, name: string, phone: string, deleted: boolean } }> | null, markers?: Array<{ __typename?: 'MenuMarkerProxy', id: number, name: string, slug: string }> | null, allergens?: Array<{ __typename?: 'MenuAllergenProxy', id: number, name: string, slug: string }> | null, company: { __typename?: 'CompanyProxy', id: number, name: string, phone: string, deleted: boolean } }> | null } | null } | null } | null };

export type GetMenuAllergensQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMenuAllergensQuery = { __typename?: 'Query', menuAllergens: Array<{ __typename?: 'MenuAllergenProxy', id: number, name: string, slug: string }> };

export type GetMenuTypesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMenuTypesQuery = { __typename?: 'Query', menuTypes: Array<{ __typename?: 'MenuTypeProxy', id: number, name: string, slug: string }> };

export type GetMenuMarkersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMenuMarkersQuery = { __typename?: 'Query', menuMarkers: Array<{ __typename?: 'MenuMarkerProxy', id: number, name: string, slug: string }> };

export type GetMenuStatusesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMenuStatusesQuery = { __typename?: 'Query', menuStatuses: Array<{ __typename?: 'MenuStatusProxy', id: number, name: string, slug: string }> };

export type GetMenuUnitsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMenuUnitsQuery = { __typename?: 'Query', relations: { __typename?: 'RelationProxy', units?: Array<{ __typename?: 'UnitProxy', id: number, name: string }> | null } };

export type GetMenuCategoriesIconsQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetMenuCategoriesIconsQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', menuCategoryIconList?: Array<{ __typename?: 'MenuCategoryIconProxy', id: number, path?: string | null, isDefault: boolean }> | null } | null } | null };

export type GetMenuPageQueryVariables = Types.Exact<{
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  id?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  menuTypeId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  isDeleted?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  companyId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetMenuPageQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', currentBranch?: { __typename?: 'BranchProxy', menus?: { __typename?: 'MenuPaginated', totalCount?: number | null, currentPage?: number | null, itemsPerPage?: number | null, pageCount?: string | null, menus?: Array<{ __typename?: 'MenuProxy', id: number, name: string, numberOfCategories: number, numberOfItems: number, deleted: boolean, branch: { __typename?: 'BranchProxy', id: number, country: { __typename?: 'Country', id: string } }, type: { __typename?: 'MenuTypeProxy', id: number }, status: { __typename?: 'MenuStatusProxy', id: number, name: string, slug: string }, categoryRelations?: Array<{ __typename?: 'MenuCategoryRelationProxy', id: number }> | null }> | null } | null } | null } | null };

export type GetCurrencyMenuItemQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetCurrencyMenuItemQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, currency?: { __typename?: 'CurrencyProxy', id: number, currency?: string | null, code?: string | null, currencySign?: string | null } | null } | null } | null };

export type GetLinkAndQrCodeMenuQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  menuId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  menusListId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetLinkAndQrCodeMenuQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', branches?: Array<{ __typename?: 'BranchProxy', menusList?: Array<{ __typename?: 'MenuProxy', id: number, name: string, qrMenuLink: string, qrMenuQrCode: string, status: { __typename?: 'MenuStatusProxy', id: number, name: string, slug: string }, type: { __typename?: 'MenuTypeProxy', id: number, name: string, slug: string }, languages?: Array<{ __typename?: 'LanguageProxy', id: number, name: string }> | null }> | null }> | null } | null } | null };

export type GetOneMenuQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  menuId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetOneMenuQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', branches?: Array<{ __typename?: 'BranchProxy', menusList?: Array<{ __typename?: 'MenuProxy', name: string, status: { __typename?: 'MenuStatusProxy', id: number, name: string, slug: string } }> | null }> | null } | null } | null };

export type GetActiveMenusByTypeQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetActiveMenusByTypeQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', branches?: Array<{ __typename?: 'BranchProxy', activeDeliveryMenu?: { __typename?: 'MenuProxy', id: number, name: string, qrMenuLink: string, qrMenuQrCode: string, type: { __typename?: 'MenuTypeProxy', id: number, name: string, slug: string }, status: { __typename?: 'MenuStatusProxy', id: number, name: string, slug: string }, languages?: Array<{ __typename?: 'LanguageProxy', id: number, name: string }> | null } | null, activeDineInMenu?: { __typename?: 'MenuProxy', id: number, name: string, qrMenuLink: string, qrMenuQrCode: string, type: { __typename?: 'MenuTypeProxy', id: number, name: string, slug: string }, status: { __typename?: 'MenuStatusProxy', id: number, name: string, slug: string }, languages?: Array<{ __typename?: 'LanguageProxy', id: number, name: string }> | null } | null, activePickUpMenu?: { __typename?: 'MenuProxy', id: number, name: string, qrMenuLink: string, qrMenuQrCode: string, type: { __typename?: 'MenuTypeProxy', id: number, name: string, slug: string }, status: { __typename?: 'MenuStatusProxy', id: number, name: string, slug: string }, languages?: Array<{ __typename?: 'LanguageProxy', id: number, name: string }> | null } | null, replaceableDineInMenus?: Array<{ __typename?: 'MenuProxy', id: number, name: string, type: { __typename?: 'MenuTypeProxy', id: number, name: string, slug: string }, status: { __typename?: 'MenuStatusProxy', id: number, name: string, slug: string }, languages?: Array<{ __typename?: 'LanguageProxy', id: number, name: string }> | null }> | null, replaceableDeliveryMenus?: Array<{ __typename?: 'MenuProxy', id: number, name: string, type: { __typename?: 'MenuTypeProxy', id: number, name: string, slug: string }, status: { __typename?: 'MenuStatusProxy', id: number, name: string, slug: string }, languages?: Array<{ __typename?: 'LanguageProxy', id: number, name: string }> | null }> | null, replaceablePickUpMenus?: Array<{ __typename?: 'MenuProxy', id: number, name: string, type: { __typename?: 'MenuTypeProxy', id: number, name: string, slug: string }, status: { __typename?: 'MenuStatusProxy', id: number, name: string, slug: string }, languages?: Array<{ __typename?: 'LanguageProxy', id: number, name: string }> | null }> | null }> | null } | null } | null };

export type GetCategoriesForMoveCategoryModalQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  locale?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCategoriesForMoveCategoryModalQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, meMenuCategories?: Array<{ __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null, childCategories?: Array<{ __typename?: 'MenuCategoryProxy', id: number, name?: string | null, nameOrigin?: string | null }> | null }> | null } | null } | null };

export type UpdateMenuStatusMutationVariables = Types.Exact<{
  menuId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
  input: Types.MenuInput;
  ignoreValidation: Types.Scalars['Boolean']['input'];
}>;


export type UpdateMenuStatusMutation = { __typename?: 'Mutation', updateMenuStatus: { __typename?: 'MenuProxy', id: number } };
